module.exports = __webpack_public_path__ + "img/unity.692ff764.jpg";